module.exports = __webpack_public_path__ + "static/media/loader.da6e02ef.gif";